<template>
  <div class="spinner-container">
    <b-spinner small></b-spinner>
    <span class="spinner-text">Thinking...</span>
  </div>
</template>

<script>
export default {
  name: 'SpinnerAnimation'
}
</script>

<style scoped>
.spinner-container {
  display: flex;
  align-items: center;
}

.spinner-text {
  margin-left: 8px;
}
</style>
